import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let CustomerGroupController = {
    getCustomerGroups: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-group/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    createCustomerGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-group/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    detailCustomerGroup: (idGroup, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-group/detail/${idGroup}`,
            method: 'GET',
        }, callback)
    },
    editCustomerGroup: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-group/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    deleteCustomerGroup: (idGroup, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/customer-group/delete/${idGroup}`,
            method: 'GET',
        }, callback)
    }

}

export default CustomerGroupController
